// extracted by mini-css-extract-plugin
export default {"grid":"XZvu_","reverse":"KmmO5","imgWrapper":"qReeM","imageContainer":"v3UaO","image":"QAn9n","text":"N1KkQ","reversedText":"CgAAA","subtitle":"P5QER","description":"PX3s3"};